'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _MultiselectWrapper = require('../OMContainers/MultiselectWrapper/MultiselectWrapper');var _MultiselectWrapper2 = _interopRequireDefault(_MultiselectWrapper);
var _multiselectsTitles = require('../../utils/multiselectsTitles');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var AgentsDropdownContainer = function AgentsDropdownContainer(properties) {var
  translate = properties.translate,value = properties.value,onChange = properties.onChange,className = properties.className,options = properties.options;
  var inputValue = (0, _multiselectsTitles.agentsTitle)(value, options, translate);

  return (
    _react2.default.createElement(_MultiselectWrapper2.default, {
      multiSelectClassName: className,
      options: options,
      title: inputValue.toString(),
      value: value,
      onChange: onChange,
      optionValueIsString: true }));


};exports.default =

AgentsDropdownContainer;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AgentsDropdownContainer/AgentsDropdownContainer.js
// module id = 2946
// module chunks = 0